import { z } from "zod";

export const apiTokenScopeSchema = z.enum(["read", "write"]);
export type ApiTokenScope = z.infer<typeof apiTokenScopeSchema>;

export const createApiTokenSchema = z.object({
  name: z.string().trim().min(3).max(80),
  scope: apiTokenScopeSchema,
  gueltigTage: z.number().int().min(1).max(365).default(90),
});
export type CreateApiTokenInput = z.infer<typeof createApiTokenSchema>;

export const apiTokenSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  kind: z.enum(["pat", "oauth_access", "oauth_refresh"]),
  scope: apiTokenScopeSchema,
  prefix: z.string(),
  createdAt: z.string(),
  expiresAt: z.string(),
  lastUsedAt: z.string().nullable(),
  revokedAt: z.string().nullable(),
  employee: z.object({ id: z.string().uuid(), fullName: z.string() }).optional(),
  /**
   * Eintrag steht für eine ganze OAuth-Freigabe (Client × Person), nicht für
   * eine einzelne Zeile; `name` ist der Client-Name. Widerruf beendet die
   * Freigabe.
   */
  oauthGrant: z.boolean().optional(),
});
export type ApiToken = z.infer<typeof apiTokenSchema>;

/** Antwort beim Anlegen: der Klartext erscheint genau dieses eine Mal. */
export const createdApiTokenSchema = apiTokenSchema.extend({ klartext: z.string() });
export type CreatedApiToken = z.infer<typeof createdApiTokenSchema>;

export const apiTokenListSchema = z.object({ items: z.array(apiTokenSchema) });
export type ApiTokenList = z.infer<typeof apiTokenListSchema>;
